// src/com/common_code/CommonCode.js
import React, { useEffect, useRef, useState } from 'react';
// import { styled } from '@mui/material/styles';
import { CircularProgress, IconButton } from '@mui/material';
import CachedIcon from '@mui/icons-material/Cached'; // refresh
import { useLazyQuery, useReactiveVar } from '@apollo/client';
import { useSnackbar } from 'notistack';
import SearchBox from '../../common/SearchBox';
import {ContentConainer, ContentHeader, ControlBox, ToolBox} from '../../common/TopViewControl';
import FlexyTable from '../../common/flexytable/FlexyTable';
import { AppObject, AppStyle, AppWord } from '../../value/AppConst';
import { commonCodeListRepo } from '../../value/AppModel';
import {
    LIST_COMMON_CODE
} from './CommonCodeGql';
import { CommonCodeDictionary, addCommonCodeUniqueKey } from './CommonCodeDict';
import { useAlertSetter } from '../../api/app-hook';

/**
 * 공통코드관리.
 * (COMMON_CODE) 정보 View Controller
 * Using React with MUI5
 * Project: NewTOP for cloud
 * 2024-08-22 15:41:37 using DbdbTap
 */
export default function CommonCode() {
    const commonCodeListData = useReactiveVar(commonCodeListRepo);
    const [searchText, setSearchText] = useState('');
    const addAlert = useAlertSetter();
    const { enqueueSnackbar } = useSnackbar();
    const lastReloadRef = useRef(0);

    // ##### Call GraphQL to get List #####
    const [getCommonCodeList, responseList] = useLazyQuery(LIST_COMMON_CODE, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteGetList(data, option)},
		onError: (error) => addAlert({title: CommonCodeDictionary.errorTitle.Get, message: [error.message]})
    });

    const getCommonCodeListNow = () => {
        getCommonCodeList();
        lastReloadRef.current = new Date().getTime()/1000;
    };

    useEffect(() => {
        const diff = new Date().getTime()/1000 - commonCodeListData.when;
        if(diff > 300 || commonCodeListData.records.length === 0)
            getCommonCodeListNow();
    }, []);

    // >>>>>>>>> callbacks <<<<<<<<<<<<<
    const onCompleteGetList = (data, clientOption) => {
        if(data.commonCodeList) {
            commonCodeListRepo({when:new Date().getTime()/1000, records:addCommonCodeUniqueKey(data.commonCodeList)});
        }
    };

    // >>>>>>>>> Event Handler <<<<<<<<<<<<<

    const onClickReload = () => {
        const diff = new Date().getTime()/1000 - lastReloadRef.current;
        if(diff < 60) {
            enqueueSnackbar(AppWord.ReloadNotInOneMinute, {variant:'info', autoHideDuration:2000});
        }
        else getCommonCodeListNow();
    };


    const onChangeSearchText = (text) => {
        setSearchText(text);
    };

    return(
        <ContentConainer>
            <ContentHeader>
                <ControlBox>
                    <SearchBox
                        value={searchText}
                        onChangeText={onChangeSearchText}
                    />
                </ControlBox>
                <ToolBox>
                    {
                        responseList.loading
                        ?
                        <CircularProgress size={20} />
                        :
                        <IconButton
                            color={AppStyle.mui.inherit}
                            onClick={onClickReload}
                        >
                            <CachedIcon />
                        </IconButton>}
                </ToolBox>
            </ContentHeader>
            <FlexyTable
                name={CommonCodeDictionary.tableProps.tableId}
                tableProps={CommonCodeDictionary.tableProps}
                records={commonCodeListData.records}
                search={searchText}
                tools={[]}
            />
        </ContentConainer>
    );
}
